import { useNavigate } from 'react-router-dom';

const Legal = () => {
  const navigate = useNavigate();
  const pTag = 'font-medium text-sm mb-5';
  const h2Tag = 'font-semibold text-xl mb-2';
  const h3Tag = 'font-medium text-base mb-2';

  return (
    <div>
      <button
        className="w-22 h-7 ml-3 mt-4 bg-secondary text-white font-semibold text-sm rounded-md"
        onClick={() => navigate('/')}
      >
        <p className="">Zurück</p>
      </button>
      <div className="flex justify-center">
        <div className="max-w-[1385px] mx-5 mt-5">
          <h1 className="font-semibold text-2xl mb-10">Impressum</h1>
          <p className={`${pTag}`}>Angaben gemäß § 5 TMG</p>
          <p className={`${pTag}`}>
            amperias GmbH
            <br />
            Max-Planck-Straße 22
            <br />
            50858 Köln
          </p>
          <p className={`${pTag}`}>
            Registergericht: Kiel
            <br />
            Registernummer: HRB 20336 KI
            <br />
            Umsatzsteuer-Identifikationsnummer: DE322442721
          </p>
          <h2 className={`${h2Tag}`}>Vertreten durch</h2>
          <p className={`${pTag}`}>
            Dr. Torsten Sowa
            <br />
            Carl-Heinz Genzel
          </p>
          <h2 className={`${h2Tag}`}>Haftungsausschluss</h2>
          <h3 className={`${h3Tag}`}>Haftung für Inhalte</h3>
          <p className={`${pTag}`}>
            Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für
            die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können
            wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir
            gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
            allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir
            als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
            gespeicherte fremde Informationen zu überwachen oder nach Umständen
            zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
            Informationen nach den allgemeinen Gesetzen bleiben hiervon
            unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
            Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
            Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese
            Inhalte umgehend entfernen.
          </p>
          <h3 className={`${h3Tag}`}>Haftung für Links</h3>
          <p className={`${pTag}`}>
            Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren
            Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
            fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
            verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
            der Seiten verantwortlich. Die verlinkten Seiten wurden zum
            Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
            Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht
            erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten
            Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung
            nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir
            derartige Links umgehend entfernen.
          </p>
          <h2 className={`${h2Tag}`}>Urheberrecht</h2>
          <p className={`${pTag}`}>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
            diesen Seiten unterliegen dem deutschen Urheberrecht. Die
            Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
            Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
            schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            Downloads und Kopien dieser Seite sind nur für den privaten, nicht
            kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser
            Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte
            Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
            gekennzeichnet. Sollten Sie trotzdem auf eine
            Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
            entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
            werden wir derartige Inhalte umgehend entfernen.
          </p>
          <h2 id="privacy" className={`${h2Tag}`}>
            Datenschutz
          </h2>
          <p className={`${pTag}`}>
            Die Nutzung unserer Webseite ist in der Regel ohne Angabe
            personenbezogener Daten möglich. Soweit auf unseren Seiten
            personenbezogene Daten (beispielsweise Name, Anschrift oder
            E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets
            auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche
            Zustimmung nicht an Dritte weitergegeben. Wir weisen darauf hin,
            dass die Datenübertragung im Internet (z.B. bei der Kommunikation
            per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz
            der Daten vor dem Zugriff durch Dritte ist nicht möglich. Der
            Nutzung von im Rahmen der Impressumspflicht veröffentlichten
            Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich
            angeforderter Werbung und Informationsmaterialien wird hiermit
            ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich
            ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung
            von Werbeinformationen, etwa durch Spam-Mails, vor.
          </p>
          <p className={`${pTag} mb-0 mt-10`}>
            Impressum vom Impressum Generator der Kanzlei Hasselbach,
            Rechtsanwälte für Arbeitsrecht und Familienrecht
          </p>
        </div>
      </div>
    </div>
  );
};

export default Legal;
